/* eslint-disable */
import React from "react";
import { Link, useLocation } from "react-router-dom";

// Import inhouse icons
import DashIcon from "@/components/icons/DashIcon";
import { FiChevronRight } from "react-icons/fi";
import { useStorePath } from "@hooks/useStorePath";

export function SidebarLinks(props) {
  let location = useLocation();
  const { storePath } = useStorePath();
  const { routes } = props;

  // verifies if routeName is the one active (in browser input)
  const activeRoute = (routePath) => {
    return location.pathname.startsWith(storePath(routePath));
  };

  const createGroupedLinks = (routes) => {
    // Flatten all visible routes.
    // A pathless child is an index route, not a nav destination - without this
    // guard it renders as a nameless link to /admin/undefined.
    const allLinks = routes
      .flatMap((route) => route.children || [])
      .filter((child) => !child.hidden && child.path && child.name);

    // Group by section
    const sections = [...new Set(allLinks.map((link) => link.section))];

    return (
      <>
        {sections.map((sectionName, sectionIndex) => {
          const sectionLinks = allLinks.filter((link) => link.section === sectionName);

          return (
            <div key={sectionIndex}>
              {/* Divider between groups (Wix-style, no section label) */}
              {sectionIndex > 0 && (
                <div className="mx-5 my-2 border-t border-[#2a313d]" />
              )}

              {sectionLinks.map((child, index) => {
                const isActive = activeRoute(child.path);
                const hasChildren =
                  Array.isArray(child.children) && child.children.some((c) => c && !c.index);

                const textColor = isActive
                  ? "text-white"
                  : "text-[#c7ccd6] group-hover:text-white";

                // Help icon renders white (per design request)
                const isHelp = child.path === "help-support";
                const iconColor = isActive || isHelp
                  ? "text-white"
                  : "text-[#c7ccd6] group-hover:text-white";

                return (
                  <Link to={storePath(child.path)} key={index} className="group block">
                    <div
                      className={`flex items-center justify-between px-5 py-[9px] transition-colors ${
                        isActive ? "bg-[#3a4150]" : "hover:bg-[#232a36]"
                      }`}
                    >
                      <div className="flex items-center gap-2.5">
                        <span className={iconColor}>
                          {child.icon ? (
                            React.cloneElement(child.icon, { className: "h-[15px] w-[15px]" })
                          ) : (
                            <DashIcon />
                          )}
                        </span>
                        <span className={`text-[13px] font-medium ${textColor}`}>
                          {child.name}
                        </span>
                      </div>

                      {hasChildren && (
                        <FiChevronRight className="h-4 w-4 text-white" />
                      )}
                    </div>
                  </Link>
                );
              })}
            </div>
          );
        })}

      </>
    );
  };

  return createGroupedLinks(routes);
}

export default SidebarLinks;
